import script from "./ShareCalculation.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareCalculation.vue?vue&type=script&setup=true&lang=js"

import "./ShareCalculation.vue?vue&type=style&index=0&id=155e52b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-155e52b6"]])

export default __exports__